import { render } from "./NoVacanciesCard.vue?vue&type=template&id=9c0fe73e&scoped=true"
const script = {}

import "./NoVacanciesCard.vue?vue&type=style&index=0&id=9c0fe73e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0fe73e"]])

export default __exports__